import AuthService from '@/services/api/auth.services'
import UsersService from '@/services/api/users.services'
import store from "@/store";
import router from "@/router";

const state = {
    authToken: null,
    isAuth: false,
    lastRoute: '',
    currentUser: {},
    roles: [],
    role: 'hr'
}

const mutations = {
    SET_LASTROUTE(state, payload) {
        state.lastRoute = payload
    },

    LOGIN(state, payload) {
        state.isAuth = true
        state.authToken = payload.access_token

    },
    LOGOUT(state) {
        state.currentUser = {}
        state.isAuth = false
        localStorage.clear();

        router.push('/login')
    },
    SET_CURRENT_USER(state, payload) {
        state.currentUser = payload
    },
    SET_AUTH_TOKEN(state, payload) {
        state.authToken = payload
    },
    SET_ROLES(state, payload) {
        state.roles = payload
    },
    CLEAR_AUTH(state) {
        state.authToken = null
        state.isAuth = false
        state.currentUser = {}
        state.roles = []
        localStorage.removeItem('authToken')
        localStorage.removeItem('access_token')
    }
}

const actions = {
    refreshToken({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AuthService.post('refreshToken', payload)
                .then((response) => {
                    commit('LOGIN', response.data)

                    UsersService.getUserRoles()
                        .then((res) => {
                            commit('SET_ROLES', res.data)
                            if(state.lastRoute) {
                                router.push(state.lastRoute)
                                state.lastRoute = ''

                            }
                            return resolve(res)
                        })
                        .catch((error) => reject(error))

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    login({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('CLEAR_AUTH')
            AuthService.post('verifyAuth', payload)
                .then((response) => {
                    commit('LOGIN', response.data)

                    UsersService.getUserRoles()
                        .then((res) => {
                            commit('SET_ROLES', res.data)
                            if(state.lastRoute) {
                                router.push(state.lastRoute)
                                state.lastRoute = ''
                            }
                            return resolve(response)
                        })
                        .catch((error) => {
                            console.error('Error getting user roles:', error)
                            commit('CLEAR_AUTH')
                            return reject(error)
                        })
                })
                .catch((error) => {
                    commit('CLEAR_AUTH')
                    return reject(error)
                })
        })
    },
    logout({ commit }) {
        commit('LOGOUT')
    },
    getPersonalData({ commit }) {
        return new Promise((resolve, reject) => {
            AuthService.get('personalInfo')
                .then((response) => {
                    commit('SET_CURRENT_USER', response.data.data)
                    store.commit('app/SET_LOCALE', response.data.data.language)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    }
}

const getters = {
    isAuth: (state) => state.isAuth,
    getAuthToken: (state) => state.authToken,
    getAuthParam: (state) => {
        return {
            isAuth: state.isAuth,
            authToken: state.authToken,
            userRole: state.currentUser.role,
        }
    },
    getCurrentUser: (state) => state.currentUser,
    getUserNickname: (state) => state.currentUser.user_name,
    getHrState: (state) => state.currentUser.role_accesses ? state.currentUser.role_accesses.some(item => item.entity === 'Hr_system') : null,
    getRole: (state) => state.currentUser.role.name,
    getUserAvatar: (state) => state.currentUser.image,
    getlastRoute: (state) => state.lastRoute,
    getUserRole: (state) => state.role
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
